import { partners } from '@/mocks/cases';

const partnerImages: Record<string, string> = {
  '中国国际贸易促进委员会': 'https://readdy.ai/api/search-image?query=CCPIT%20Chinese%20trade%20promotion%20logo%20modern%20clean%20design&width=200&height=120&seq=partner-p1&orientation=landscape',
  '世界华商大会': 'https://readdy.ai/api/search-image?query=World%20Chinese%20Entrepreneurs%20Convention%20logo%20modern%20professional&width=200&height=120&seq=partner-p2&orientation=landscape',
  '亚洲开发银行': 'https://readdy.ai/api/search-image?query=Asian%20Development%20Bank%20logo%20modern%20professional%20design%20clean&width=200&height=120&seq=partner-p3&orientation=landscape',
  '中国-东盟商务理事会': 'https://readdy.ai/api/search-image?query=China%20ASEAN%20Business%20Council%20logo%20modern%20corporate%20design&width=200&height=120&seq=partner-p4&orientation=landscape',
  '国际商会': 'https://readdy.ai/api/search-image?query=International%20Chamber%20of%20Commerce%20logo%20modern%20professional%20clean&width=200&height=120&seq=partner-p5&orientation=landscape',
  '一带一路发展中心': 'https://readdy.ai/api/search-image?query=Belt%20and%20Road%20development%20center%20logo%20modern%20Chinese%20design&width=200&height=120&seq=partner-p6&orientation=landscape',
};

export default function Partners() {
  return (
    <section className="w-full px-6 md:px-10 py-14 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold tracking-widest uppercase text-foreground-400 mb-3 block">合作伙伴</span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            值得信赖的合作伙伴网络
          </h2>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-6 gap-6 items-center">
          {partners.map((partner) => (
            <div key={partner.name} className="flex flex-col items-center gap-3">
              <img
                src={partnerImages[partner.name]}
                alt={partner.name}
                className="w-full h-16 object-contain opacity-60 hover:opacity-100 transition-opacity"
              />
              <span className="text-xs text-foreground-400 text-center">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}